<template>
    <div class="home">
     
      <SolicitudInspeccionComponent />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import SolicitudInspeccionComponent from '@/components/SolicitudInspeccionComponent.vue'
  
  export default {
   // name: 'UserView',
    components: {
        SolicitudInspeccionComponent
    }
  }
  </script>